import React from 'react';
import {
  notEmptyString,
} from '@populateui/utils';
import {
  DEFAULT_EMPTY_VALUE,
} from 'core/constants';
import {
  PCCDashboardAlertDTO,
} from 'dtos';
import {
  normalizeAlerts,
} from 'pages/Dashboard/pages/Dashboard/PCCOverview/helper';
import PCCAlertActions from 'pages/Dashboard/pages/Dashboard/PCCOverview/alerts/PCCAlertActions';
import {
  PCCPatientActionContext,
} from 'pages/Dashboard/pages/Dashboard/PCCOverview/types';

type Props = {
  alerts?: PCCDashboardAlertDTO[] | null;
  patient: PCCPatientActionContext;
};

type AlertRowProps = {
  alert: PCCDashboardAlertDTO;
  patient: PCCPatientActionContext;
};

function AlertRow({ alert, patient }: AlertRowProps) {
  return (
    <div className="flex gap-2.5">
      <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-amber-400" />
      <div className="min-w-0 flex-1">
        <div className="flex flex-col gap-0.5">
          <h5 className="text-sm font-semibold text-gray-900">
            {notEmptyString(alert.label) ? alert.label : DEFAULT_EMPTY_VALUE}
          </h5>
          {notEmptyString(alert.text) && (
            <p className="text-xs leading-5 text-gray-600">{alert.text}</p>
          )}
          {notEmptyString(alert.subtext) && (
            <p className="text-[11px] leading-4 text-gray-500">{alert.subtext}</p>
          )}
        </div>
        <PCCAlertActions
          alerts={[alert]}
          patient={patient}
          className="mt-2"
        />
      </div>
    </div>
  );
}

export default function PCCAlertList({ alerts, patient }: Props) {
  const normalizedAlerts = normalizeAlerts(alerts);

  return normalizedAlerts.length > 0 ? (
    <section
      aria-label="Alerts"
      className="rounded-lg border border-gray-200 bg-white p-3"
    >
      <div className="flex flex-col gap-3">
        {normalizedAlerts.map(({ alert, key }) => (
          <AlertRow
            key={key}
            alert={alert}
            patient={patient}
          />
        ))}
      </div>
    </section>
  ) : null;
}
